import React from "react";
import './header.css';


export default function Header(){

    return(
        <div id="header" className="Header_bar">
            <div className="Header_bar_items">
                <div className="Header_bar_items_phrase">As a generalist software developer, technologies have been chosing me instead of me chosing 'em!</div>
                <div className="Header_bar_items_photo"><img src="marco_photo.png" alt="Marco Chaddoud" /></div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/Header.js